<template>
    <div>
        <div style="display: flex;justify-content: space-between;">
            <div>
                <el-input size="small" v-model="insDevModel.model" style="width: 200px;" prefix-icon="el-icon-plus"
                          placeholder="添加型号..."></el-input>
                <el-input size="small" v-model="insDevModel.type" style="width: 200px;margin-left: 5px;"
                          placeholder="设备类型"></el-input>
                <el-input size="small" v-model="insDevModel.supplier" style="width: 200px;margin-left: 5px;"
                          placeholder="供应商"></el-input>
                <el-button icon="el-icon-plus" type="danger" size="small" style="margin-left: 5px;" @click="addDevModel">添加</el-button>
            </div>
            <div>
                <el-button icon="el-icon-refresh-right" type="success" @click="initDevModels">刷新</el-button>
            </div>
        </div>

        <div style="margin-top: 10px">
            <el-table
                    :data="devModels"
                    v-loading="loading"
                    border
                    @selection-change="handleSelectionChange"
                    size="small"
                    stripe
                    style="">
                <el-table-column
                        type="selection"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="ID"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="model"
                        label="设备型号"
                        align="center"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="终端类型"
                        align="center"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="supplier"
                        label="供应商"
                        align="center"
                        width="120">
                </el-table-column>
                <el-table-column
                        align="center"
                        label="是否启用">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.enabled" color="#FFFFFF">已启用</el-tag>
                        <el-tag type="info" v-else color="#FFFFFF">未启用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip
                        align="center"
                        prop="createTime"
                        label="创建时间">
                </el-table-column>
                <el-table-column show-overflow-tooltip
                        align="center"
                        prop="updateTime"
                        label="更新时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="danger" plain size="mini" style="padding: 5px" @click="showEditView(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
                title="修改机型"
                :visible.sync="dialogVisible"
                class="dlg-normal"
                width="40%">
            <div>
                <table style="margin: auto">
                    <tr>
                        <td>
                            <el-tag class="txt-tag">设备型号</el-tag>
                        </td>
                        <td>
                            <el-input size="small" v-model="updDevModel.model"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag class="txt-tag">终端类型</el-tag>
                        </td>
                        <td>
                            <el-input size="small" v-model="updDevModel.type"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag class="txt-tag">&nbsp;&nbsp;&nbsp;供应商</el-tag>
                        </td>
                        <td>
                            <el-input size="small" v-model="updDevModel.supplier"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag class="txt-tag">是否启用</el-tag>
                        </td>
                        <td>
                            <el-switch
                                    v-model="updDevModel.enabled"
                                    active-text="启用"
                                    inactive-text="禁用">
                            </el-switch>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="updateDevModel">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: "ModelMng",
        data() {
            return {
                dialogVisible: false,
                loading: false,
                devModels: [],
                insDevModel: {
                    model: '',
                    type: '',
                    supplier:'',
                    enabled: ''
                },
                updDevModel: {
                    model: '',
                    type: '',
                    supplier:'',
                    enabled: ''
                }
            }
        },
        mounted() {
            this.initDevModels();
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            showEditView(data) {
                Object.assign(this.updDevModel, data);
                this.dialogVisible = true;
            },
            initDevModels() {
                this.loading = true;
                this.getRequest("/dev/basic/devModels").then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devModels = resp.data;
                    }
                })
            },
            addDevModel() {
                this.insDevModel.model = this._StringUtils.trim(this.insDevModel.model);
                if (this.insDevModel.model) {
                    this.postRequest("/dev/basic/addDevModel", this.insDevModel).then(resp => {
                        if (resp) {
                            this.initDevModels();
                            Object.keys(this.insDevModel).forEach(key => this.insDevModel[key] = '');
                        }
                    });
                } else {
                    this.$message.error("设备型号不可以为空!");
                }
            },
            updateDevModel() {
                this.putRequest("/dev/basic/updateDevModel", this.updDevModel).then(resp => {
                    if (resp) {
                        this.initDevModels();
                        this.dialogVisible = false;
                    }
                })
            }
        }
    }
</script>
